import script from "./ToriokiDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToriokiDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ToriokiDetail.vue?vue&type=style&index=0&id=5bdc1f78&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bdc1f78"]])

export default __exports__